import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';


@Directive({
    selector: '[ngMouseTrail]',
    standalone: false
})
export class NgMouseTrailDirective implements OnInit, OnDestroy {

	constructor(
		private elementRef: ElementRef<HTMLElement>
	) {}

	private readonly mousedownHandler = () => {
		this.elementRef.nativeElement.classList.add('mouse-trail');
	};

	private readonly mouseupHandler = () => {
		this.elementRef.nativeElement.classList.remove('mouse-trail');
	};

	ngOnInit(): void {
		const el: HTMLElement = this.elementRef.nativeElement;
		el.addEventListener('mousedown', this.mousedownHandler);
		el.addEventListener('mouseup', this.mouseupHandler);
	}

	ngOnDestroy(): void {
		const el: HTMLElement = this.elementRef.nativeElement;
		el.removeEventListener('mousedown', this.mousedownHandler);
		el.removeEventListener('mouseup', this.mouseupHandler);
	}
}
